import BookIcon from '@material-ui/icons/Book';
import PeopleIcon from '@material-ui/icons/People';
import useLocalStorage from '@rehooks/local-storage';
import * as React from 'react';
import { DashboardMenuItem, MenuItemLink } from 'react-admin';

export const Menu = () => {
  const [role] = useLocalStorage('role');
  return (
    <div>
      <DashboardMenuItem />
      {role === 'admin' ? (
        <MenuItemLink
          to="/user"
          primaryText="Users"
          leftIcon={<PeopleIcon />}
        />
      ) : null}
      <MenuItemLink
        to="/manifest"
        primaryText="Manifest"
        leftIcon={<BookIcon />}
      />
    </div>
  );
};
